
<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 11.1249L10 9.62489M10 9.62489L8.5 8.12489M10 9.62489L11.5 8.12489M10 9.62489L8.5 11.1249M16 9.93412V5.84765C16 5.52741 15.7967 5.24249 15.4938 5.13839L10.2438 3.33371C10.0858 3.27939 9.9142 3.27939 9.75618 3.33371L4.50619 5.13839C4.20334 5.24249 4 5.52741 4 5.84765V9.93412C4 13.6635 7 15.2499 10 16.8683C13 15.2499 16 13.6635 16 9.93412Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  name: 'ShieldCancelIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>
<style scoped>
</style>
